import { Dropdown } from 'primereact/dropdown';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ROLES } from '../../../constants';
import { selectIsPseudoSupervisor } from '../../../pages/login/authSlice';
import './CoachingSummary.scss';

export interface SelectTeamProps {
    selectTeamList: any;
    selectedTeam: string | undefined;
    userManagerLevel: any;
    revgenGoalTab?: boolean;
    setSelectedTeam: (team: string) => void;
    setVisible: (visible: boolean) => void;
    setSelectTeamList: (list: any) => void;
    parent?: string;
}

export const SelectTeam = ({
    selectTeamList,
    selectedTeam,
    userManagerLevel,
    revgenGoalTab,
    setSelectedTeam,
    setVisible,
    setSelectTeamList,
    parent,
}: SelectTeamProps) => {
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    useEffect(() => {
        if (revgenGoalTab) {
            const list = [];
            if (parent === 'triads') {
                if (!ROLES.Supervisor2AndAbove.includes(userManagerLevel)) {
                    list.push({ value: 'myActivity', label: 'My Coaching Observations' });
                }
                if (isPseudoSupervisor === true || ROLES.SupervisorORManager.includes(userManagerLevel)) {
                    const directReporteOptions = [
                        { value: 'myTeamActivity', label: 'My Team’s Coaching Observations' },
                        { value: 'search', label: 'Search Oracle ID' },
                    ];
                    list.push(...directReporteOptions);
                }
            } else {
                if (!ROLES.Manager.includes(userManagerLevel)) {
                    list.push({ value: 'myActivity', label: 'My Goals' });
                }
                if (isPseudoSupervisor === true || ROLES.SupervisorORManager.includes(userManagerLevel)) {
                    const directReporteOptions = [
                        { value: 'myTeamActivity', label: 'My Team’s Goals' },
                        { value: 'search', label: 'Search Oracle ID' },
                    ];
                    list.push(...directReporteOptions);
                }
            }
            const prevSelectedTeam = localStorage.getItem('selectedTeam');
            setSelectTeamList(list);

            if (prevSelectedTeam && list.some(item => item.value === prevSelectedTeam)) {
                setSelectedTeam(prevSelectedTeam);
            } else {
                setSelectedTeam(
                    ROLES.Supervisor2AndAbove.includes(userManagerLevel) || isPseudoSupervisor === true
                        ? 'myTeamActivity'
                        : 'myActivity'
                );
            }
        } else {
            const list = [{ value: 'myActivity', label: 'My Activity' }];
            if (isPseudoSupervisor === true || ROLES.SupervisorORManager.includes(userManagerLevel)) {
                const directReporteOptions = [
                    { value: 'myTeamActivity', label: 'My Team’s Activity' },
                    { value: 'search', label: 'Search' },
                ];
                list.push(...directReporteOptions);
            }
            const prevSelectedTeam = localStorage.getItem('selectedTeam');
            if (prevSelectedTeam && list.some(item => item.value === prevSelectedTeam)) {
                setSelectedTeam(prevSelectedTeam);
            } 
            else if(parent === 'capstab'){
                setSelectedTeam('myTeamActivity');
            }
            else{
                setSelectedTeam('myActivity');
            }
            setSelectTeamList(list);
        }
        
    }, []);
    return (
        <div className="content" data-testid="select-team">
            <label htmlFor="select-team">Select Team</label>
            <Dropdown
                id="select-team"
                placeholder="Select Team"
                className="custom-dropdown"
                options={selectTeamList}
                optionValue={'value'}
                optionLabel={'label'}
                value={selectedTeam}
                onChange={(e) => {
                    setSelectedTeam(e.target.value);
                    localStorage.setItem('selectedTeam', e.target.value);
                    localStorage.removeItem('searchedUser');
                    if (e.target.value === 'search') {
                        setVisible(true);
                    }
                }}
            />
        </div>
    );
};
